export class PaginationOptions {
  public static readonly DEFAULT_PAGE_SIZE = 50;
  public static readonly INITIAL_PAGE = 1;

  public readonly page: number;
  public readonly pageSize: number;

  constructor({
    page,
    pageSize,
  }: {
    page?: number;
    pageSize?: number;
  } = {}) {
    this.page = page ?? 1;
    this.pageSize = pageSize ?? PaginationOptions.DEFAULT_PAGE_SIZE;
  }

  public toQueryParams(): URLSearchParams {
    return new URLSearchParams({
      page: this.page.toString(),
      page_size: this.pageSize.toString(),
    });
  }
}
